import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Layout } from 'antd';
import LayoutOne from '../../layouts/LayoutOne';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AddAddress, GetAllAddress } from '../../store/actions/user';
import Swal from 'sweetalert2';
import { CreatePayment } from '../../store/actions/Payment';
import { getCartProducts } from '../../store/actions/cart-actions';
import { getCities } from '../../store/actions/city';
import { getStates } from '../../store/actions/state';
import { getCountries } from '../../store/actions/country';
import { applyCoupon } from '../../store/slices/cart-slice';

const DeliveryDetailsPage = () => {
  const [sameAsDelivery, setSameAsDelivery] = useState(false);
  const [hasGST, setHasGST] = useState(false);
  const [showNewAddressForm, setShowNewAddressForm] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [deliveryCharges, setDeliveryCharges] = useState(0);

  const navigate = useNavigate();
  const dispatch = useDispatch()
  const addressesFromStore = useSelector((state) => state?.userList?.address_list);
  const deliveryCost = useSelector((state) => state.settings.list[0])
  console.log(deliveryCost, "delivery cost")
  const PaymentData = useSelector((state) => state.payment.list);
  const [addresses, setAddresses] = useState([]);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        await dispatch(GetAllAddress());
        await dispatch(getCities())
        await dispatch(getStates())
        await dispatch(getCountries())
      } catch (error) {
        console.error('Error fetching addresses:', error);
      }
    };

    fetchAddresses();
  }, [dispatch]);

  useEffect(() => {
    const FetchCart = async () => {
      try {
        await dispatch(getCartProducts());
      } catch (error) {
        console.error('Error fetching addresses:', error);
      }
    };

    FetchCart();
  }, [dispatch]);

  const countryList = useSelector((state) => state.country.list);
  const stateList = useSelector((state) => state.state.list);
  const cityList = useSelector((state) => state.city.list);

  useEffect(() => {
    if (Array.isArray(addressesFromStore)) {
      const mappedAddresses = addressesFromStore.map(addr => {
        // Find names by IDs
        const countryName = countryList.find(c => c._id === addr.countryId)?.name || addr.country || '';
        const stateName = stateList.find(s => s._id === addr.stateId)?.name || addr.state || '';
        const cityName = cityList.find(c => c._id === addr.cityId)?.name || addr.city || '';
        return {
          ...addr,
          country: countryName,
          state: stateName,
          city: cityName,
        };
      });
      setAddresses(mappedAddresses);
    }
  }, [addressesFromStore, countryList, stateList, cityList]);

  // Calculate delivery charges based on selected address
  useEffect(() => {
    if (selectedAddress && deliveryCost) {
      const isGujarat = selectedAddress.state?.toLowerCase().includes('gujarat');
      const isSurat = selectedAddress.city?.toLowerCase().includes('surat');

      if (isGujarat && !isSurat) {
        // City is out of Surat but in Gujarat - use stateGujarat charge
        setDeliveryCharges(deliveryCost.stateGujarat || 0);
      } else if (!isGujarat) {
        // State is not Gujarat - use countryIndia charge
        setDeliveryCharges(deliveryCost.countryIndia || 0);
      } else {
        // City is Surat - no delivery charges
        setDeliveryCharges(0);
      }
    } else {
      setDeliveryCharges(0);
    }
  }, [selectedAddress, deliveryCost]);

  const handleCityChange = (selectedCityId) => {
    // Find the city object from cityList by id
    const selectedCity = cityList.find(city => city._id === selectedCityId);

    if (selectedCity) {
      setFormData({
        ...formData,
        cityId: selectedCity._id,
        stateId: selectedCity.stateId,     // assuming your city object has stateId
        countryId: selectedCity.countryId, // assuming your city object has countryId
      });

      // You can also update local states if you have separate ones for state and country
      setState(selectedCity.stateId);
      setCountry(selectedCity.countryId);
    } else {
      // Clear if no city selected
      setFormData({
        ...formData,
        cityId: "",
        stateId: "",
        countryId: "",
      });
      setState("");
      setCountry("");
    }
  };

  const [cartTotalPrice, setCartTotalPrice] = useState(0);
  const { cartItems, appliedCoupon, discountedTotal } = useSelector((state) => state.cart);

  useEffect(() => {
    let total = 0;
    cartItems.forEach((item) => {
      // const discountedPrice = getDiscountPrice(item.price, item.discount) || item.cartPrice;
      const discountedPrice = item.price || item.cartPrice;
      total += discountedPrice * item.qty;
    });
    setCartTotalPrice(total);

    // If there's an applied coupon, recalculate the discounted total
    if (appliedCoupon) {
      dispatch(applyCoupon({ coupon: appliedCoupon, cartTotal: total }));
    }
  }, [cartItems, appliedCoupon, dispatch]);

  const finalCartTotal = appliedCoupon ? cartTotalPrice - appliedCoupon.amt : cartTotalPrice;
  const grandTotal = finalCartTotal;

  const path = useLocation();

  const handleAddressSelect = (address) => {
    setSelectedAddress(address);
    setShowNewAddressForm(false);
  };

  const handleNewAddressClick = () => {
    setSelectedAddress(null);
    setShowNewAddressForm(true);
  };

  const [formData, setFormData] = useState({
    addressLine1: "",
    addressLine2: "",
    cityId: "",    // changed to cityId
    stateId: "",   // changed to stateId
    countryId: "", // changed to countryId
    pinCode: "",
  });

  const handleAddNewAddress = async () => {
    const payload = {
      type: "home",
      addressLine1: formData.addressLine1.trim(),
      addressLine2: formData.addressLine2?.trim(),
      cityId: formData.cityId,
      stateId: formData.stateId,
      countryId: formData.countryId,
      pinCode: formData.pinCode.trim(),
      isDefault: true,
    };

    await dispatch(AddAddress(payload));
    await dispatch(GetAllAddress());

    setFormData({
      addressLine1: "",
      addressLine2: "",
      cityId: "",    // changed to cityId
      stateId: "",   // changed to stateId
      countryId: "", // changed to countryId
      pinCode: "",
    });

    Swal.fire("Success", "Address added successfully.", "success");
    setShowNewAddressForm(false);
  };

  useEffect(() => {
    const defaultAddress = addresses.find((addr) => addr.isDefault === true);
    if (defaultAddress) {
      setSelectedAddress(defaultAddress);
    }
  }, [addresses]);

  const handleReviewPayment = async () => {
    if (!selectedAddress) {
      Swal.fire("Error", "Please select a delivery address before proceeding.", "error");
      return;
    }

    const payload = {
      selectedAddress: {
        name: selectedAddress.name || "Default Name",
        mobile: selectedAddress.mobile || 9662200076,
        pinCode: selectedAddress.pinCode,
        address: selectedAddress.addressLine1 + (selectedAddress.addressLine2 ? `, ${selectedAddress.addressLine2}` : ''),
        cityId: selectedAddress.cityId || selectedAddress.city,
        countryId: selectedAddress.countryId || selectedAddress.country,
        stateId: selectedAddress.stateId || selectedAddress.state,
        type: selectedAddress.type
      },
      cartIds: cartItems.map(item => item.cartId || ""),
      cartTotal: grandTotal, // Include delivery charges in total
      deliveryCharge: deliveryCharges
    };
    const paymentPayload = {
      cartTotalPrice,                // Total price of items in cart
      discount: appliedCoupon?.amt,  // Discount from applied coupon (optional chaining)
      deliveryCharges,               // Delivery charges, if any          // Assuming you 
    };


    navigate("/payment", {
      state: {
        payload,
        paymentPayload
      },
    });
  };

  const getDeliveryInfo = () => {
    if (!selectedAddress || deliveryCharges === 0) return null;

    const isGujarat = selectedAddress.state?.toLowerCase().includes('gujarat');
    const isSurat = selectedAddress.city?.toLowerCase().includes('surat');

    if (isGujarat && !isSurat) {
      return {
        type: "State Delivery",
        description: `Delivery within Gujarat (Outside Surat)`,
        icon: "🚛"
      };
    } else if (!isGujarat) {
      return {
        type: "National Delivery",
        description: `Delivery outside Gujarat`,
        icon: "🚚"
      };
    }
    return null;
  };

  const deliveryInfo = getDeliveryInfo();

  return (
    <LayoutOne>
      <div className="container py-4">
        <div className="row">
          <div className="col-lg-8" style={{ padding: "0px 40px 0px 40px" }}>
            <div className="d-flex mb-4">
              <div className="me-4 d-flex align-items-center justify-content-center gap-2">
                <span className="fw-bold">DELIVERY DETAILS</span>
                <div
                  style={{
                    width: '10px',
                    height: '10px',
                    backgroundColor: path.pathname === "/delivery-details" ? 'green' : '#000',
                    borderRadius: '50%',
                  }}
                ></div>
              </div>

              <div className="me-4 d-flex justify-content-center align-items-center gap-2">
                <span className="fw-bold">REVIEW & PAYMENTS</span>
                <div
                  style={{
                    width: '10px',
                    height: '10px',
                    backgroundColor: path.pathname === "/payment" ? 'green' : '#000',
                    borderRadius: '50%',
                  }}
                ></div>
              </div>
            </div>

            {/* Address Selection */}
            <div className="mb-4">
              <h5 className="mb-3">Select Delivery Address</h5>
              <div className="row g-3 mb-3">
                {addresses.map((address) => (
                  <div key={address._id} className="col-md-6 mb-3">
                    <div
                      className={`card address-card ${selectedAddress?._id === address._id ? 'selected' : ''}`}
                      onClick={() => handleAddressSelect(address)}
                      style={{
                        cursor: 'pointer',
                        border: selectedAddress?._id === address._id ? '2px solid #ffa500' : '1px solid #dee2e6',
                        backgroundColor: selectedAddress?._id === address._id ? '#fff3e0' : '#ffffff',
                        transition: 'all 0.3s ease'
                      }}
                    >
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                          <h6 className="card-title mb-0">
                            <i className=" me-2"></i>
                            {address.type.charAt(0).toUpperCase() + address.type.slice(1)} Address
                          </h6>
                          {address.isDefault && (
                            <span className="badge bg-success">Default</span>
                          )}
                          {selectedAddress?._id === address._id && (
                            <i className="fas fa-check-circle text-success"></i>
                          )}
                        </div>

                        <p className="card-text mb-1">
                          <strong>Address:</strong> {address.addressLine1}
                        </p>

                        {address.addressLine2 && address.addressLine2 !== address.addressLine1 && (
                          <p className="card-text mb-1">{address.addressLine2}</p>
                        )}

                        <p className="card-text mb-1">
                          <strong>City:</strong> {address.city}, {address.state}
                        </p>

                        <p className="card-text mb-1">
                          <strong>Country:</strong> {address.country}
                        </p>

                        <p className="card-text mb-1">
                          <strong>Pin Code:</strong> {address.pinCode}
                        </p>

                        <div className="mt-2">

                        </div>
                      </div>
                    </div>
                  </div>
                ))}

              </div>

              <button
                className="btn btn-outline-primary"
                onClick={handleNewAddressClick}
              >
                + Add New Address
              </button>
            </div>

            {/* New Address Form with Transition */}
            <div className={`new-address-form ${showNewAddressForm ? 'visible' : ''}`}>
              <h5 className="mb-3">New Delivery Address</h5>
              <div className="row g-3" style={{ padding: "0px 40px 0px 40px" }}>

                <div className="col-12">
                  <input type="text" className="form-control" value={formData.addressLine1} placeholder="Address Line 1..." onChange={(e) => setFormData({ ...formData, addressLine1: e.target.value })} />
                </div>
                <div className="col-12">
                  <input type="text" className="form-control" value={formData.addressLine2} placeholder="Address Line 2 (Optional Area)..." onChange={(e) => setFormData({ ...formData, addressLine2: e.target.value })} />
                </div>
                <div className="col-12">
                  <input type="text" className="form-control" value={formData.pinCode} placeholder="Pincode." onChange={(e) => setFormData({ ...formData, pinCode: e.target.value })} />
                </div>
                <div className="col-md-4 mb-4">
                  <label style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#4a5568',
                    marginBottom: '8px',
                    display: 'block'
                  }}>
                    City
                  </label>
                  <select
                    className="form-select"
                    style={{
                      borderRadius: '10px',
                      border: '2px solid #e2e8f0',
                      padding: '12px 16px',
                      fontSize: '16px',
                      transition: 'all 0.3s ease'
                    }}
                    value={formData.cityId}
                    onChange={(e) => handleCityChange(e.target.value)}
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  >
                    <option value="">Select City</option>
                    {/* Show all cities instead of filtered ones when user is selecting */}
                    {cityList.map((cityItem) => (
                      <option key={cityItem._id} value={cityItem._id}>
                        {cityItem.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4 mb-4">
                  <label style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#4a5568',
                    marginBottom: '8px',
                    display: 'block'
                  }}>
                    State
                  </label>
                  <select
                    className="form-select"
                    style={{
                      borderRadius: '10px',
                      border: '2px solid #e2e8f0',
                      padding: '12px 16px',
                      fontSize: '16px',
                      transition: 'all 0.3s ease'
                    }}
                    disabled
                    value={formData.stateId}
                    onChange={(e) => {
                      setState(e.target.value);
                    }}

                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  >
                    <option value="">Select State</option>
                    {stateList.map((state) => (
                      <option key={state._id} value={state._id}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4 mb-4">
                  <label style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#4a5568',
                    marginBottom: '8px',
                    display: 'block'
                  }}>
                    Country
                  </label>
                  <select
                    className="form-select"
                    style={{
                      borderRadius: '10px',
                      border: '2px solid #e2e8f0',
                      padding: '12px 16px',
                      fontSize: '16px',
                      transition: 'all 0.3s ease'
                    }}
                    value={formData.countryId}
                    onChange={(e) => {
                      setCountry(e.target.value);
                    }}
                    disabled
                    onFocus={(e) => e.target.style.borderColor = '#667eea'}
                    onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                  >
                    <option value="">Select Country</option>
                    {countryList.map((country) => (
                      <option key={country._id} value={country._id}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>
                <button className='btn btn-primary' onClick={handleAddNewAddress}>Save Address</button>
              </div>
            </div>
          </div>
          <div className="col-lg-4" style={{ padding: "0px 40px" }}>
            <div className="card d-flex flex-column h-90">
              <div className="card-body flex-grow-1 d-flex flex-column">
                <h5 className="card-title mb-4">Your Order ({cartItems.length})</h5>
                {/* Scrollable product list */}
                <div style={{ maxHeight: "300px", overflowY: "auto", marginBottom: "1rem" }}>
                  {cartItems.map((item, index) => (
                    <div key={index} className="d-flex mb-3" style={{ borderBottom: "1px solid black", borderRadius: "8px" }}>
                      <img
                        src={item?.images[0]?.src || item?.seriesImages[0]?.src}
                        alt={"NOT EXIST"}
                        style={{ width: '60px', height: '60px', objectFit: 'contain' }}
                        className="me-3"
                      />
                      <div>
                        <div className="fw-bold">
                          {item.name} {item.refurbished && '(Refurbished)'}
                        </div>
                        <div>₹{item.price.toLocaleString()}</div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Pricing Summary */}
                <div>
                  <hr />
                  {appliedCoupon ? (
                    <>
                      <div className="d-flex justify-content-between mb-1">
                        <span>Original Price</span>
                        <span>₹{cartTotalPrice.toLocaleString()}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-1">
                        <span>Coupon Discount</span>
                        <span className="text-success">-₹{appliedCoupon.amt.toLocaleString()}</span>
                      </div>
                      <div className="d-flex justify-content-between mb-2">
                        <span><strong>Subtotal</strong></span>
                        <span><strong>₹{(cartTotalPrice - appliedCoupon.amt).toLocaleString()}</strong></span>
                      </div>
                    </>
                  ) : (
                    <div className="d-flex justify-content-between mb-2">
                      <span>Subtotal</span>
                      <span>₹{cartTotalPrice.toLocaleString()}</span>
                    </div>
                  )}

                  {/* Modern Delivery Charges Section */}
                  {deliveryInfo && (
                    <div className="mt-3 mb-3">
                      <div
                        style={{
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          borderRadius: '12px',
                          padding: '16px',
                          color: 'white',
                          position: 'relative',
                          overflow: 'hidden'
                        }}
                      >
                        {/* Background decoration */}
                        <div
                          style={{
                            position: 'absolute',
                            top: '-20px',
                            right: '-20px',
                            width: '80px',
                            height: '80px',
                            background: 'rgba(255,255,255,0.1)',
                            borderRadius: '50%'
                          }}
                        ></div>

                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center">
                            <div
                              style={{
                                fontSize: '24px',
                                marginRight: '12px',
                                background: 'rgba(255,255,255,0.2)',
                                borderRadius: '8px',
                                padding: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              {deliveryInfo.icon}
                            </div>
                            <div>
                              <div style={{ fontWeight: '600', fontSize: '16px' }}>
                                {deliveryInfo.type}
                              </div>
                              <div style={{ fontSize: '13px', opacity: '0.9' }}>
                                {deliveryInfo.description}
                              </div>
                            </div>
                          </div>
                          <div style={{
                            fontWeight: '700',
                            fontSize: '18px',
                            textShadow: '0 1px 2px rgba(0,0,0,0.2)'
                          }}>
                            ₹{deliveryCharges.toLocaleString()}
                          </div>
                        </div>

                        {/* Estimated delivery time */}
                        <div className="mt-2 pt-2" style={{
                          borderTop: '1px solid rgba(255,255,255,0.2)',
                          fontSize: '12px',
                          opacity: '0.8'
                        }}>
                          <i className="fas fa-clock me-1"></i>
                          Estimated delivery: 3-5 business days
                        </div>
                      </div>
                    </div>
                  )}

                  {deliveryCharges === 0 && selectedAddress && (
                    <div className="mt-3 mb-3">
                      <div
                        style={{
                          background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                          borderRadius: '12px',
                          padding: '16px',
                          color: 'white',
                          textAlign: 'center'
                        }}
                      >
                        <div style={{ fontSize: '20px', marginBottom: '8px' }}>🎉</div>
                        <div style={{ fontWeight: '600', fontSize: '16px' }}>
                          Free Delivery!
                        </div>
                        <div style={{ fontSize: '13px', opacity: '0.9' }}>
                          No delivery charges for Surat city
                        </div>
                      </div>
                    </div>
                  )}

                  <hr />
                  <div className="d-flex justify-content-between mb-2">
                    <span style={{ fontSize: '18px', fontWeight: '700' }}>Grand Total</span>
                    <span style={{ fontSize: '18px', fontWeight: '700', color: '#e74c3c' }}>
                      ₹{grandTotal + deliveryCharges}
                    </span>
                  </div>
                </div>
              </div>

              {/* Bottom fixed button */}
              <div className="card-footer bg-white border-0 d-flex ">
                <button
                  className="btn btn-success px-4 w-100"
                  style={{ color: "white" }}
                  onClick={handleReviewPayment}
                  disabled={!selectedAddress && !showNewAddressForm}
                >
                  REVIEW & PAYMENT
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutOne>
  );
};

export default DeliveryDetailsPage;